/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
export const CUSTOM_APP_DATA = {
  address: {
    textProfile: {
      imageUrl: "../../../../assets/company/address/images/textProfile.png",
      description: "Text Profile Img",
    },
    gps: {
      imageUrl: "../../../../assets/company/address/images/GPSBlue.svg",
      description: "GPS",
    },
    searchIcon: {
      imageUrl: "../../../../assets/company/address/images/ico.svg",
      description: "Searchicon",
    },
    marker: {
      imageUrl: "../../../../assets/company/address/images/ico1.svg",
      description: "Marker",
    },
    formGps: {
      imageUrl: "../../../../assets/company/address/images/formGPS.svg",
      description: "FormGps",
    },
  },
  landing_page_banner: [
    {
      imageUrl: "/assets/landing-page/images/COVID-19 Vechile Control.jpg",
      description: "banner-image_0",
    },
  ],
  landing_page_banner_tab: [
    {
      imageUrl: "/assets/landing-page/images/banner_image_2.jpg",
      description: "banner-image_0",
    },
  ],
  landingPage: {
    nvipani: {
      desktop: {
        imageUrl: "/assets/landing-page/images/banner_desktop.jpg",
        description: "nvipani-banner-desktop",
      },
      mobile: {
        imageUrl: "/assets/landing-page/images/banner_image_1.jpg",
        description: "nvipani-banner-desktop",
      },
    },
  },
  landing_page_banner_desktop: [
    {
      // imageUrl: '/assets/landing-page/images/banner_desktop.jpg',
      imageUrl: "/assets/landing-page/images/traffic-lights-6010_640.jpg",
      description: "banner-image_0",
    },
    {
      imageUrl: "/assets/landing-page/images/banner_desktop.jpg",
      description: "banner-image_1",
    },
    {
      imageUrl: "/assets/landing-page/images/banner_desktop.jpg",
      description: "banner-image_2",
    },
    {
      imageUrl: "/assets/landing-page/images/banner_desktop.jpg",
      description: "banner-image_3",
    },
  ],
  nVipaniLogo: {
    imageUrl: "/assets/landing-page/images/nVipani logo mono SVG@2x.png",
    description: "banner-image_4",
  },
  covidImages: {
    nvipaniLogo: "assets/landing-page/images/nvipani-logo.png",
    rachakondaPoliceLogo: "assets/landing-page/images/rachakonda-police.jpg",
    telanganaPoliceLogo: "assets/landing-page/images/Telangana-police-logo.jpg",
  },
  footerImagesForLandingPage: [
    {
      imageUrl: "/assets/landing-page/images/nVipani logo mono SVG@2x.png",
      description: "banner-image_4",
    },
    {
      imageUrl: "/assets/landing-page/images/Ask us more.svg",
      description: "banner-image_5",
    },
    {
      imageUrl: "/assets/landing-page/images/Facebook.svg",
      description: "banner-image_6",
    },
    {
      imageUrl: "/assets/landing-page/images/Linkedin.svg",
      description: "banner-image_7",
    },
    {
      imageUrl: "/assets/landing-page/images/Youtube.svg",
      description: "banner-image_8",
    },
    {
      imageUrl: "/assets/landing-page/images/valuchain_image.svg",
      description: "banner-image_9",
    },
  ],
  landing_page_images: [
    {
      imageUrl: "/assets/landing-page/images/green_layer.svg",
      description: "green_layer_4",
    },
    {
      imageUrl: "/assets/landing-page/images/valuchain_image.svg",
      description: "valuchain_image_5",
    },
    {
      text: "Proactive Business at Anywhere Everywhere",
    },
  ],
  abdLogo: {
    logo: "../../../../../../../assets/attendance/abdIcon.png",
  },
  flags: {
    india: {
      imageUrl: "../../../assets/company/companyInfo/icons8-india-96.png",
      description: "IN",
    },
    england: {
      imageUrl:
        "../../../assets/company/list-countries/images/united-kingdom.svg",
      description: "UK",
    },
    america: {
      imageUrl:
        "../../../assets/company/list-countries/images/united-states.svg",
      description: "US",
    },
    singapore: {
      imageUrl: "../../../assets/company/list-countries/images/singapore.svg",
      description: "SG",
    },
  },
  userImage: [
    {
      imageUrl: "/assets/user/input-images/caution.svg",
      description: "caution_0",
    },
    {
      imageUrl: "/assets/user/input-images/blueEyeOff.svg",
      description: "eye_1",
    },
    {
      imageUrl: "/assets/user/input-images/hide.svg",
      description: "hide_2",
    },
    {
      // imageUrl: '/assets/company/list-countries/images/india.svg',
      imageUrl: "/assets/user/input-images/profileImage.png",
      description: "profile_3",
    },
    {
      imageUrl: "/assets/user/input-images/key.svg",
      description: "key_4",
    },
    {
      imageUrl: "/assets/user/input-images/mail.svg",
      description: "mail_5",
    },
    {
      imageUrl: "/assets/user/input-images/shield.svg",
      description: "shield_6",
    },
    {
      imageUrl: "/assets/user/input-images/blackEye.svg",
      description: "view_7",
    },
    {
      imageUrl: "/assets/user/input-images/help.svg",
      description: "help_8",
    },
    {
      imageUrl: "/assets/user/input-images/mail_disabled.svg",
      description: "mail_disabled_9",
    },
    {
      imageUrl: "/assets/user/input-images/arrow_white.svg",
      description: "arrow_10",
    },
    {
      imageUrl: "/assets/user/input-images/white_help.svg",
      description: "white_help_11",
    },
    {
      imageUrl: "/assets/user/input-images/mobile.svg",
      description: "mobile_12",
    },
    {
      imageUrl: "/assets/user/input-images/GST.svg",
      description: "GST_13",
    },
    {
      imageUrl: "/assets/user/input-images/arrow_green.svg",
      description: "arrow_14",
    },
    {
      imageUrl: "/assets/user/input-images/check_white.svg",
      description: "check_white_15",
    },
    {
      imageUrl: "/assets/user/input-images/check_green.svg",
      description: "check_green_16",
    },
    {
      imageUrl: "/assets/user/input-images/arrow_green_desktop.svg",
      description: "check_green_17",
    },
    {
      imageUrl: "/assets/user/input-images/search_icon.svg",
      description: "search_icon_18",
    },
  ],
  printLabels: {
    templates: [
      {
        src: "/assets/print/newqr.png",
        name: "newqr.png",
        selected: false,
      },
      {
        src: "/assets/print/BRQR-s.png",
        name: "BRQR-s.png",
        selected: false,
      },
      {
        src: "/assets/print/Br.png",
        name: "Br.png",
        selected: false,
      },
      {
        src: "/assets/print/Qr.png",
        name: "Qr.png",
        selected: false,
      },
      {
        src: "/assets/print/BrQr.png",
        name: "BrQr.png",
        selected: false,
      },
      {
        src: "/assets/print/BrQr1.png",
        name: "BrQr1.png",
        selected: false,
      },
      {
        src: "/assets/print/BrQr2.png",
        name: "BrQr2.png",
        selected: false,
      },
      {
        src: "/assets/print/BrQr3.png",
        name: "BrQr3.png",
        selected: false,
      },
    ],
  },

  //   landing_page_images : {
  //     greenLayer: {
  //       imageUrl : '/assets/landing-page/images/green_layer.svg',
  //       description : 'green_layer_4'
  //     },
  //     valuchainImage: {
  //       imageUrl : '/assets/landing-page/images/valuchain_image.svg',
  //       description : 'valuchain_image_5'
  //     },
  //     Text: {
  //       text : 'Proactive Business at Anywhere Everywhere'
  //     }
  //   },
  userImages: {
    caution: {
      imageUrl: "/assets/user/input-images/caution.svg",
      description: "caution_0",
    },
    eye: {
      imageUrl: "/assets/user/input-images/blueEyeOff.svg",
      description: "eye_1",
    },
    hide: {
      imageUrl: "/assets/user/input-images/hide.svg",
      description: "hide_2",
    },
    home: {
      // imageUrl: '/assets/company/list-countries/images/india.svg',
      imageUrl: "/assets/user/input-images/profileImage.png",
      description: "profile_3",
    },
    key: {
      imageUrl: "/assets/user/input-images/key.svg",
      description: "key_4",
    },
    mail: {
      imageUrl: "/assets/user/input-images/mail.svg",
      description: "mail_5",
    },
    shield: {
      imageUrl: "/assets/user/input-images/shield.svg",
      description: "shield_6",
    },
    view: {
      imageUrl: "/assets/user/input-images/blackEye.svg",
      description: "view_7",
    },
    help: {
      imageUrl: "/assets/user/input-images/help.svg",
      description: "help_8",
    },
    mailDisabled: {
      imageUrl: "/assets/user/input-images/mail_disabled.svg",
      description: "mail_disabled_9",
    },
    arrow: {
      imageUrl: "/assets/user/input-images/arrow_white.svg",
      description: "arrow_10",
    },
    whiteHelp: {
      imageUrl: "/assets/user/input-images/white_help.svg",
      description: "white_help_11",
    },
    mobile: {
      imageUrl: "/assets/user/input-images/mobile.svg",
      description: "mobile_12",
    },
    gst: {
      imageUrl: "/assets/user/input-images/GST.svg",
      description: "GST_13",
    },
    arrowGreen: {
      imageUrl: "/assets/user/input-images/arrow_green.svg",
      description: "arrow_14",
    },
    checkWhite: {
      imageUrl: "/assets/user/input-images/check_white.svg",
      description: "check_white_15",
    },
    checkGreen: {
      imageUrl: "/assets/user/input-images/check_green.svg",
      description: "check_green_16",
    },
    arrowGreenDesktop: {
      imageUrl: "/assets/user/input-images/arrow_green_desktop.svg",
      description: "check_green_17",
    },
    search: {
      imageUrl: "/assets/user/input-images/search_icon.svg",
      description: "search_icon_18",
    },

    homeImage: {
      imageUrl: "assets/user/input-images/home.svg",
      description: "home_image_19",
    },
    camera: "assets/icons/camera-green.svg",
  },
  settingsImages: {
    settingImage0: {
      imageUrl: "/assets/default/svg/building.svg",
      description: "0",
    },
    settingImage1: {
      imageUrl: "/assets/default/svg/man.svg",
      description: "1",
    },
    settingImage2: {
      imageUrl: "/assets/default/svg/pair-of-bills.svg",
      description: "2",
    },
    settingImage3: {
      imageUrl: "/assets/default/svg/surface1.svg",
      description: "3",
    },
    settingImage4: {
      imageUrl: "/assets/default/svg/employee.svg",
      description: "4",
    },
    settingImage5: {
      imageUrl: "/assets/default/svg/Shape.svg",
      description: "5",
    },
    settingImage6: {
      imageUrl: "/assets/default/svg/trolley-2.svg",
      description: "6",
    },
    settingImage7: {
      imageUrl: "/assets/default/svg/shopping-bag.svg",
      description: "7",
    },
    settingImage8: {
      imageUrl: "/assets/default/svg/search.svg",
      description: "8",
    },
    settingImage9: {
      imageUrl: "/assets/default/svg/script.svg",
      description: "9",
    },
    settingImage10: {
      imageUrl: "/assets/default/svg/down.svg",
      description: "10",
    },
    settingImage11: {
      imageUrl: "/assets/default/svg/back.svg",
      description: "11",
    },
    settingImage12: {
      imageUrl: "/assets/default/svg/help.svg",
      description: "12",
    },
    settingImage13: {
      imageUrl: "/assets/default/svg/Delete.svg",
      description: "13",
    },
    settingImage14: {
      imageUrl: "/assets/default/svg/Edit.svg",
      description: "14",
    },
    settingImage15: {
      imageUrl: "/assets/default/svg/add-button.svg",
      description: "15",
    },
    settingImage16: {
      imageUrl: "/assets/default/svg/deselected.svg",
      description: "16",
    },
    settingImage17: {
      imageUrl: "/assets/default/svg/selected.svg",
      description: "17",
    },
  },
  errorImages: {},
  // company: [
  //   {
  //   }
  // ],
  user_url: {
    url: "/user",
  },

  postLogin: {
    url: "/homePage/attendance/log-work",
  },
  user: {
    features: "/users/trainingsetdata",
    addMiniUser: "/user/addMiniUser",
    UserCheck: "/user/userCheck",
    Otp: "/user/otpuserpassword",
    onboard: "/user/useronboard",
    auth: "/auth/signin",
    signout: "/auth/signout",
    flagdata: "/countries",
    branches: "/branches",
    inventories: "/busUnitInventories/",
    itemMaster: "/itemMasterListByCompanyId",
    segments: "/companysegments",
    category: "/companysegmentCategories",
    subcategory1: "/categories/",
    hsnCodes: "/hsncodeSearch/",
    changePassword: "/users/password",
    productBrand: "/productBrand",
    uom: "/unitofmeasures",
    stories: "/companyStories",
    evidences: "/companyEvidences",
    segmentStories: "/segmentStories",
    taxes: "/taxSearch",
    getEvidenceTargets: "/getEvidenceTargets",
    itemMasterGroup: "/itemmastergroup",
    inventoryGroup: "/inventorygroup",
    productBrandVarietyByProductCategory:
      "/productBrandVarietyByProductCategory",
    productBrandVariety: "/productBrandVariety",
    currentUser: "/users/me",
    evidencesRemove: "/evidencesremove",
    faceFeatures: "/users/faceimageupdate",
    activateUser: "/auth/activeUser",
    activateUserLink: "/auth/activateUser",
  },
  inventories: {
    list: "/busUnitInventories/",
    stockItemMaster: "/stockItemMaster",
    stockMasters: "/stockMasters",
    generateStockItemMaster: "/generateStockItemMaster",
    deleteStockItems: "/stockitemsremove/",
    activeInventories: "/inventoriesactive",
    inactiveInventories: "/inventoriesinactive",
    deleteInventories: "/inventoriesremove",
    convertTypeBoxing: "/inventories/createInventoryConversion",
    convertTypeUnboxing: "/inventories/createInventoryConversion",
    summaryDataInventories: "/inventorysummary",
    scanData: "/scanProduct",
    safetyStock: "/safetyStockInventory",
  },
  attendance: {
    people: "/persons",
    personsBusinessUnit: "/personsbusinessUnit",
    personData: "/personData",
    offlineScanData: "/personsMultiple",
    attendanceSettings: "/updatelocationsettings",
    userLogout: "/personDataLogOut",
  },
  tracker: {
    requests: "/passRequest",
    massUpdate: "/massUpdate",
    detailedView: "/passMasters",
    downloadPass: "/passDownload",
    passTransaction: "/passTransactions",
    passRequestSummary: "/passRequestSummary",
    passTransactionData: "/passTransactionsData",
    passTransactionPassMasterList: "/passTransactionPassMasterList",
    scanByPass: "/scanByPass",
    scanByPolice: "/scanByPolice",
    getPassSummary: "/getPassSummary",
  },
  vehicleTracking: {
    scanData: "/scanData",
  },
  ledger: {
    ledger: "/ledgerEntries",
    reports: "/reports",
    paymentModes: "/companypaymentmodes",
    contactOrders: "/contactOrders",
    contacts: "/targetLegerBusinessUnit",
  },
  contacts: {
    contacts: "/contacts/all",
    contactsUpdateInfo: "/contacts/",
    updateAssignedContact: "/contactupdate/",
    businessUnitById: "/contactBusinessUnit/",
    addContact: "/contacts",
    getContactBusinessUnit: "/contactBusinessUnitData/",
    getCompanyByName: "/getCompaniesByName/",
    getContactSummary: "contactssummary",
    groups: {
      customerContacts: "/contacts/customers",
      supplierContacts: "/contacts/suppliers",
      createGroup: "/groups",
    },
  },

  bulk_url: {
    viewloadExample: "/fileexport",
    importFile: "importFile",
    // importFile : 'importFile',
  },
  createProduct: {
    url: "/categories",
  },
  createProductBrand: {
    url: "/productBrand",
  },
  createGroup: {
    url: "/itemmastergroup",
  },
  getItemGroup: {
    url: "/inventoryGroupQuery",
  },
  itemMaster: {
    removeItemMaster: "/itemmastersremove",
    inactiveItemMaster: "/itemMasterInactive",
    activeItemMaster: "/itemMasterActive",
    itemMasterGroupItemMasters: "/getItemMasterGroup",
    itemMaster: "/itemMaster/",
    itemMasterGroupById: "/itemmastergroup/",
  },
  inventory: {
    inventoriesById: "/inventories/",
    addBatch: "/stockMaster/",
    addItem: "/saveBatchStockItem/",
    updateInventoryBatch: "/stockMaster/",
    inventoryGroup: "/getInventoryAggregate",
    inventoryGroupInventories: "/getInventoryGroup",
    createInventoryMaster: "/inventories/createInventoryMaster",
    inventoryGroupById: "/inventorygroup/",
    conversions: "/itemConversions/",
  },
  businessUnit: {
    // search: '/branchBySearch',
    businessUnitUsers: "/brancheusers/",
    inchargingUnits: "/inChargeBusinessUnits",
  },
  evidence: {
    save: "/saveEvidence",
    editTag: "/tagEditEvidence",
  },
  expiryItems: {
    expiryData: "/expiryCount",
  },
  vehicles: {
    vehiclesList: "/vehicles",
    vehiclesDetails: "/vehicletransactions",
    vehicleData: "/vehicleData",
  },
  companyUrl: {
    company: "/companyByName",
    configurationURL: "/configurations",
    businessUnitsByCompany: "/getBusinessUnitsByCompany/",
    registrationCategories: "/registrationCategories",
    companySettings: "/companySettingsData",
    update: "/companies/",
    businessUnitsList: "/branches",
    businessUsersList: "/businessUsers",
    updateBusUsersList: "/brancheusers/",
    addBusUser: "/auth/adduser",
    userGroupsList: "/auth/userGroups",
    businessUsersSummary: "/businessUsersSummary",
    updateBusUnits: "/branches/",
    updateBusinessUser: "/auth/updateuser",
    branchSequence: "/branchsequence",
    businessUserGroupActions: "/auth/companyUserMassActions",
    businessUnitsRemove: "/businessUnitsRemove",
    businessUnitsEnable: "/businessUnitsEnable",
    businessUnitsDisable: "/businessUnitsDisable",
    whiteShopEnable: "/massWhiteShopUpdate",
    businessUnitMassActions: "/auth/businessUnitMassActions",
    unitOfMeasures: "/unitofmeasures",
    addMassUsersToUnit: "/auth/addMassUsersToUnit",
    fileUpload: "/fileupload",
    updateProfile: "/users",
    allSegments: "/companyDataSegments",
    businessUnitsSummary: "/branchsummary",
    userCategoriesList: "/auth/userCategories",
    payRoles: "/payRoles",
    updateSettings: "/updateSettings",
    order: "/branchresetorder",
    offer: "/branchsequenceoffer",
    invoice: "/branchresetinvoice",
    resetAll: "/branchresetall",
    inchargeUsers: "/companyInchargeUsers",
    getParentBusinessUnit: "/getParentBusinessUnits",
    languages: "/getLanguages",
    channel: "/channel",
    allChannels: "/channel-list",
    // company:'/companyByName',
    // registrationCategories:'/registrationCategories',
    // update:'/companies/'
    // mainbusinessUnitsList:'/branches',
    // businessUsersList:'/businessUsers',
    // updateBusUsersList:'/brancheusers/',
    // addBusUser:'/auth/adduser',
    // userGroupsList:'/auth/userGroups',
    // businessUnitsList:'/branches',
    // businessUnitsList:'/companyInchargeUsers/',
    // businessUsersSummary:'/businessUsersSummary',
    // updateBusinessUser:'/auth/updateuser'
    // // branchSequence:'/branchsequence?businessUnitId='
  },
  payment: {
    paymentTerms: "/paymentterms",
    paymentModes: "/companypaymentmodes",
    companyPaymentTerms: "/companypaymentterms",
  },
  uom: {
    byId: "/unitOfMeasures",
  },
  businessUnitExpiryThreshold: {
    getExpiryBusinessUnitData: "/getExpiryOptionProducts/",
    updateExpiryProducts: "/updateExpiryProducts/",
  },
  fileupload: {
    fileupload: "/fileupload",
    fileuploadb64: "/saveImage",
  },
  inchargingBusinessUnits: {
    inchargingUnits: "/businessUnitsByIncharge",
  },
  reports: {
    reports: "/reports",
    reportPath: "/reportPath",
  },
  businessUserImages: {
    male: "../../../../../../../assets/attendance/man-avatar.svg",
    female: "../../../../../../../assets/attendance/woman-avatar.svg",
  },
  settings_images: [
    {
      imageUrl: "/assets/default/svg/building.svg",
      description: "0",
    },
    {
      imageUrl: "/assets/default/svg/man.svg",
      description: "1",
    },
    {
      imageUrl: "/assets/default/svg/pair-of-bills.svg",
      description: "2",
    },
    {
      imageUrl: "/assets/default/svg/surface1.svg",
      description: "3",
    },
    {
      imageUrl: "/assets/default/svg/employee.svg",
      description: "4",
    },
    {
      imageUrl: "/assets/default/svg/Shape.svg",
      description: "5",
    },
    {
      imageUrl: "/assets/default/svg/trolley-2.svg",
      description: "6",
    },
    {
      imageUrl: "/assets/default/svg/shopping-bag.svg",
      description: "7",
    },
    {
      imageUrl: "/assets/default/svg/search.svg",
      description: "8",
    },
    {
      imageUrl: "/assets/default/svg/script.svg",
      description: "9",
    },
    {
      imageUrl: "/assets/default/svg/down.svg",
      description: "10",
    },
    {
      imageUrl: "/assets/default/svg/back.svg",
      description: "11",
    },
    {
      imageUrl: "/assets/default/svg/help.svg",
      description: "12",
    },
    {
      imageUrl: "/assets/default/svg/Delete.svg",
      description: "13",
    },
    {
      imageUrl: "/assets/default/svg/Edit.svg",
      description: "14",
    },
    {
      imageUrl: "/assets/default/svg/add-button.svg",
      description: "15",
    },
    {
      imageUrl: "/assets/default/svg/deselected.svg",
      description: "16",
    },
    {
      imageUrl: "/assets/default/svg/selected.svg",
      description: "17",
    },
  ],
  electionIcons: {
    like: "assets/election/icon-3.svg",
    dislike: "assets/election/icon-2.svg",
    heart: "assets/election/icon-1.svg",
    profile: "assets/election/icon.svg",
    total: "assets/election/total.svg",
    profileSummary: "assets/election/profile-election.svg",
    voted: "assets/election/voted-icon.svg",
    notVoted: "assets/election/close.svg",
    absent: "assets/election/disable.svg",
  },
  contact_info: {
    copyright: "© 2019 | All rights reserved.",
  },
  segment_icons: {
    choose: "/assets/company/segments/images/008__choose.svg",
    down: "/assets/company/segments/images/down.svg",
    help: "/assets/company/segments/images/Help.svg",
  },
  companyInfo_icons: {
    menu:
      "assets/company/companyInfo/menu-button-of-three-horizontal-lines.svg",
    noContacts: "assets/company/companyInfo/zero-contacts.png",
    nVipaniUser: "assets/icons/nvipani-user.png",
  },
  location_url: {
    location_info: "/locations",
  },
  area_url: {
    area_info: "/areas",
  },
  zone_url: {
    zone_info: "/zones",
  },
  tradingType_icons: {
    choose: "/assets/company/trading-type/images/008__choose.svg",
  },
  homePage_icons: {
    myCompany: "/assets/company/companySideNav/company icon.svg",
    evidences: "/assets/company/companySideNav/evidences.svg",
    inventory: "/assets/company/companySideNav/inventory.svg",
    setting: "/assets/company/companySideNav/setting.svg",
    storyMaster: "/assets/company/companySideNav/storyMaster.svg",
    greenDot: "/assets/company/companySideNav/greenDot.svg",
    threeLines: "/assets/company/companySideNav/three-lines.svg",
    valueChainLogo: "assets/company/companySideNav/valuchain logo.png",
    nvipaniLogo: "/assets/default/images/nvipani-logo-small.png",
    itemMasterIcons: {
      downloadIcon: "assets/homepage/itemMasterPage/027__download.svg",
      cloudIcon: "assets/homepage/itemMasterPage/030__cloud_upload.svg",
      googleDriveIcon: "assets/homepage/itemMasterPage/google-drive.svg",
      editIcon: "assets/homepage/itemMasterPage/083__setting_edit.svg",
      list: "assets/homepage/itemMasterPage/list_item.svg",
      filter: "assets/homepage/itemMasterPage/FilterBTN.svg",
    },
    stockItemMasterIcons: {
      deleteIcon: "assets/icons/delete-24px.svg",
    },
  },
  header_icons: {
    down: "assets/header/down.png",
  },
  viewIcons: {
    crossMark: "assets/view/cancel-red.svg",
    checkMark: "assets/view/Tick.svg",
  },
  productCreationIcons: {
    sourceNoData: "assets/itemMasterProductCreation/Group 9917.svg",
    sourceData: "assets/itemMasterProductCreation/Mask Group 3.svg",
    arrow: "assets/itemMasterProductCreation/Arrow.svg",
    add: "assets/itemMasterProductCreation/Group 9953.svg",
    wrong: "assets/itemMasterProductCreation/error.svg",
    plus: "assets/itemMasterProductCreation/16x16.png",
    googleDriveIcon: "assets/itemMasterProductCreation/google-drive.svg",
    cloudIcon: "assets/itemMasterProductCreation/030__cloud_upload.svg",
    active: "assets/itemMasterProductCreation/008__choose.svg",
    completed: "assets/itemMasterProductCreation/008__choose.svg",
    inactive: "assets/itemMasterProductCreation/008__choose (1).svg",
  },
  BusinessUnitsicons: {
    blackArrow: "/assets/company/companySideNav/Business-units/Black-Arrow.svg",
    whiteTick: "/assets/company/companySideNav/Business-units/White-tick.svg",
    greenTick: "/assets/company/companySideNav/Business-units/Green-tick.svg",
    camera: "/assets/company/companySideNav/Business-units/camera.svg",
    filter: "/assets/company/companySideNav/Business-units/FilterBTN.svg",
    list: "/assets/company/companySideNav/Business-units/list.svg",
    person: "/assets/company/companySideNav/Business-units/person.png",
    eye: "/assets/company/companySideNav/Business-units/blueEye.svg",
    noImage: "/assets/company/companySideNav/Business-units/default.png",
    cross: "/assets/company/companySideNav/Business-units/camera.svg",
    defaultBusinessUnitImage: "assets/default/svg/park.svg",
  },
  replaceImageUpload: {
    image: "modules/inventories/img/itemmaster/itemmaster.svg",
  },
  regex: {
    // regex for GSTIN number
    exp_GSTIN:
      "/^[0-9]{2,2}[a-zA-Z]{5,5}[0-9]{4,4}[a-zA-Z]{1,1}[1-9a-zA-Z]{1,1}[a-zA-Z]{1,1}[0-9a-zA-Z]{1,1}$/",
    // regex for mobile and email id
    exp_mail: /^(([_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})))+$/,
    //         /^(?:\d{10,11}|([_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})))$/
    // regex for phone '/^[0-9]{10}$/'
    exp_phone: "/^[0-9]{10,11}$/",
    // regex for PAN
    exp_PAN: "/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/",
    // regex for IFSC code
    exp_IFSC: "/^[A-Za-z]{4}0[A-Za-z0-9]{6}$/",
    // regex for bankAccountNumber
    exp_accountNumber: "/^[0-9]{9,18}$/",
    // regex for pincode
    exp_pincode: "/^[0-9]{6}$/",
    // regex for aadharNumber
    exp_aadhar: "/^[0-9]{12}$/",
    // regex for ESI
    exp_esi: "/^[0-9]{17}$/",
    // regex for vehicle
    exp_vehicleNumber: "/^[A-Z0-9]{7,10}$/",
  },
  evidencesIcons: {
    delete: "assets/homepage/evidencesPage/Delete.svg",
    down: "assets/homepage/evidencesPage/down.svg",
    edit: "assets/homepage/evidencesPage/Edit.svg",
    filter: "assets/homepage/itemMasterPage/FilterBTN.svg",
    camera: "assets/homepage/evidencesPage/094__camera.svg",
    blackDown: "assets/itemMasterProductCreation/down.svg",
    search: "assets/homepage/evidencesPage/search.svg",
    script: "assets/homepage/evidencesPage/script.svg",
    blackEdit: "assets/homepage/evidencesPage/EditBlack.svg",
  },
  inventoryImagesIcons: {
    delete: "assets/itemMasterProductCreation/baseline_close_white_18dp.png",
    inventoryConvert: "assets/icons/convert.svg",
    noInventoryData: "assets/icons/noData.svg",
  },
  offerIcons: {
    attach: "assets/offer/paper-clip-16.png",
    close: "assets/offer/baseline_close_white_18dp.png",
    cameraSwitch: "assets/icons/switch-cam.png",
    counterOfferImage: "assets/offer/counterOffer.svg",
    defaultOfferImage: "assets/company/companySideNav/offer.svg",
  },
  supportedBrowsers: [
    {
      lowest_version: 70,
      name: "chrome",
    },
    {
      lowest_version: 13,
      name: "safari",
    },
    {
      lowest_version: 70,
      name: "firefox",
    },
    {
      lowest_version: 57,
      name: "opera",
    },
    {
      lowest_version: 17,
      name: "edge",
    },
  ],
  promolinkSupportedBrowsers: [
    {
      lowest_version: 65,
      name: "chrome",
      image: "assets/icons/chrome.png",
    },
    {
      lowest_version: 13,
      name: "safari",
      image: "assets/icons/safari.png",
    },
    {
      lowest_version: 85,
      name: "edge",
      image: "assets/icons/ms-edge.png",
    },
  ],
};
